import { FunctionComponent, useCallback, useEffect, useMemo, useRef, useState } from "react";
import smugEyes from "../../images/MC Smug.png";
import eyesOpenSprite from "../../images/MC face only.png";
import eyesClose from "../../images/talk_closed_eyes_closed_final.png";
import xmas_smugEyes from "../../images/xmas_MC Smug.png";
import xmas_eyesOpenSprite from "../../images/xmas_MC.png";
import xmas_eyesClose from "../../images/xmas_talk_closed_eyes_closed_final.png";
import valentine_smugEyes from "../../images/valentine_MC Smug.png";
import valentine_eyesOpenSprite from "../../images/valentine_MC.png";
import valentine_eyesClose from "../../images/valentine_talk_closed_eyes_closed_final.png";
import bowSprite from "../../images/Maidchan-bow 4 small.png";
import xmasBowSprite from "../../images/Maidchan-bow xmas.png";
import valentineBowSprite from "../../images/Maidchan-bow valentine.png"
import "./Maidchan.css";
import MaidchanJumpScare, { scareReady } from "./MaidchanJumpScare";
import Cookies from "js-cookie";
import arigatou from "../../audio/Arigatou.mp3";
import { VoiceLine, VoiceLine2, sayLine } from "./MaidchanVoice";
import { IChatMetadata } from "../navigation/NavigationNew";
import { Get, Post } from "../../utils/api";
import Modal from "../shared/Modal";
import Button from "../shared/Button";
import { CrossIcon } from "../shared/Icon";

// Maidchan sprites: Z:\E backup\Programing\Maidchan Web\Maidchan Screenshots
// Z:\E backup\Programing\Maidchan Web

interface IProps {
	chatData: IChatMetadata | null;
	setChatData?: React.Dispatch<React.SetStateAction<IChatMetadata | null>>;
}

export enum BowReason {
	Greeting = 1,
	Thanks = 2,
	Found = 3,
	Annoyed = 4,
	Baka = 5,
}

export enum ScareReason {
	Random = 1,
	Clicked = 2,
}

export let maidchanBow = (reason?: BowReason) => {};
export let maidchanBah = () => {
	maidchanBahInternal();
};
export let foundMaidchan = () => {};
let maidchanBahInternal = () => {};

const Maidchan: FunctionComponent<IProps> = (props) => {
	const { chatData, setChatData } = props;

	const tickMS = 100;
	const [eyesOpen, setEyesOpen] = useState(true);
	const [smug, setSmug] = useState(false);
	const [guest, setGuest] = useState(false);
	const [triggerBow, setTriggerBow] = useState<BowReason | boolean>(false);
	const [bow, setBow] = useState(false);
	const [scare, setScare] = useState<ScareReason | false>(false);
	const [blinkTimer, setBlinkTimer] = useState(0);
	const [location, setLocation] = useState(0);
	const [dead, setDead] = useState(false);
	const [clicks, setClicks] = useState(0);

	const closedStyle = useMemo(() => {
		if (!scare && !bow) {
			return { display: "block" };
		}
		return { display: "none" };
	}, [bow, scare]);

	const openStyle = useMemo(() => {
		if (!scare && !bow && eyesOpen) {
			return { display: "block" };
		}
		return { display: "none" };
	}, [bow, eyesOpen, scare]);

	const smugStyle = useMemo(() => {
		if (!scare && !bow && smug) {
			return { display: "block" };
		}
		return { display: "none" };
	}, [bow, scare, smug]);

	const bowStyle: React.CSSProperties = useMemo(() => {
		if (!scare && bow) {
			const style: React.CSSProperties = { backgroundPositionX: "108%" };
			return style;
		}
		return { opacity: 0 };
	}, [bow, scare]);

	const endScare = useCallback(() => {
		setScare(false);
	}, []);

	const onGreeting = useCallback(() => {
		Get<void>("/chat/notifyGreeting");
	}, []);

	useEffect(() => {
		if (!triggerBow) { return; }
		let timeout: NodeJS.Timeout | null = null;
		
		const onPlaying = () => {
			setBow(true);

			if (triggerBow === BowReason.Greeting) {
				onGreeting();
			}
		}
		const onEnded = () => {
			setBow(false); setTriggerBow(false);
		}
		const sayLineAndBow = (line: VoiceLine2) => {
			sayLine(line, onPlaying, onEnded);
		}

		if (triggerBow === BowReason.Baka) {
			sayLine(VoiceLine2.Baka, () => {}, onEnded);
			return;
		}

		if (chatData?.isHiding) {
			if (triggerBow === BowReason.Thanks) {
				sayLine(VoiceLine2.Baka, () => {}, onEnded);
			}
			return;
		}

		if (triggerBow === BowReason.Thanks) {
			sayLineAndBow(VoiceLine2.Thanks);
		}
		else if (triggerBow === BowReason.Greeting) {
			if (chatData?.lastGreeting) {
				const lastGreeting = new Date(chatData.lastGreeting);
				const fourHoursAgo = new Date();
				fourHoursAgo.setHours(fourHoursAgo.getHours() - 4);
				if (lastGreeting > fourHoursAgo) {
					setBow(false);
					setTriggerBow(false);
					return;
				}
			}
			
			sayLineAndBow(VoiceLine2.Greeting);
		}
		else if (triggerBow === BowReason.Found) {
			sayLineAndBow(VoiceLine2.Returned);
		}
		else if (triggerBow === BowReason.Annoyed) {
			sayLine(VoiceLine2.Annoyed, () => {}, onEnded);
		}
		return () => { timeout && clearTimeout(timeout); };
	}, [chatData?.lastGreeting, onGreeting, triggerBow, chatData?.isHiding]);

	const setImages = useCallback(() => {
		maidchanBow = (reason?: BowReason) => {
			setTriggerBow(reason ?? BowReason.Thanks);
		}
		maidchanBahInternal = () => setScare(ScareReason.Random);
		foundMaidchan = () => {
			console.log("Found Maidchan!");
			setChatData?.(x => {
				if (!x) { return null; }
				return { ...x, isHiding: false, hidingMessage: null };
			});
			maidchanBow(BowReason.Found);
			setImages();
		}
		const date = new Date();
		const month = date.getMonth();
		const day = date.getDate();
		var closed = document.getElementById('mcPicEyesClosed');
		var open = document.getElementById('mcPicEyesOpen');
		var smug = document.getElementById('mcPicSmugEyes');
		var bow = document.getElementById('mcPicBow');
		if (month === 11 && (day === 24 || day === 25)) {	// XMAS
			if (closed) { closed.style.backgroundImage = "url('" + xmas_eyesClose + "')"; }
			if (open) { open.style.backgroundImage = "url('" + xmas_eyesOpenSprite + "')"; }
			if (smug) { smug.style.backgroundImage = "url('" + xmas_smugEyes + "')"; }
			if (bow) { bow.style.backgroundImage = "url('" + xmasBowSprite + "')"; }
			return;
		}
		if (month === 1 && day === 14) {	// Valentine's
			if (closed) { closed.style.backgroundImage = "url('" + valentine_eyesClose + "')"; }
			if (open) { open.style.backgroundImage = "url('" + valentine_eyesOpenSprite + "')"; }
			if (smug) { smug.style.backgroundImage = "url('" + valentine_smugEyes + "')"; }
			if (bow) { bow.style.backgroundImage =  "url('" + valentineBowSprite + "')"; }
			return;
		}
		if (closed) { closed.style.backgroundImage = "url('" + eyesClose + "')"; }
		if (open) { open.style.backgroundImage = "url('" + eyesOpenSprite + "')"; }
		if (smug) { smug.style.backgroundImage = "url('" + smugEyes + "')"; }
		if (bow) { bow.style.backgroundImage = "url('" + bowSprite + "')"; }
	}, []);

	const toggleBlink = useCallback(() => {
		setEyesOpen(!eyesOpen);
	}, [eyesOpen]);

	const blink = useCallback(() => {
		if ((Math.random() > .85 && blinkTimer > 40) || (blinkTimer > 90)) {
			setBlinkTimer(1);
			toggleBlink();
			return;
		}
		else if (!eyesOpen && blinkTimer > 1) { //Keeps eyes shut for an extra cycle
			setBlinkTimer(1);
			toggleBlink();
			return;
		}
		setBlinkTimer(blinkTimer + 1);
	}, [blinkTimer, eyesOpen, toggleBlink]);

	useEffect(() => {
		const isHentai = window.location.href.indexOf('Hentai') >= 0;
		if (smug === isHentai) { return; }
		setSmug(isHentai);
	}, [smug, blinkTimer]);

	useEffect(() => {
		setTimeout(blink, tickMS);
	}, [blink]);

	useEffect(() => {
		setImages();
	}, [setImages]);

	useEffect(() => {
		const positions = 4;
		const onMouseMove = (event: MouseEvent) => {
			const avatar = document.getElementsByClassName("maidChan")[0]?.getBoundingClientRect();
			const content = document.getElementsByClassName("main")[0]?.getBoundingClientRect();
			if (!avatar || !content) { return; }
			const { x: mouseX, y: mouseY } = event;

			const withinX = mouseX > avatar.x && mouseX < avatar.x + avatar.width && (mouseX < content.x || mouseX > content.x + content.width);
			const withinY = mouseY > avatar.y && mouseY < avatar.y + avatar.height;

			if (withinX && withinY) {
				setLocation(x => {
					const pos = positions - (guest ? 1 : 0);
					return (x + (Math.floor(Math.random() * (pos - 1))) + 1) % pos;
				});
				return;
			}

			if (guest) {
				setLocation(x => x % (positions - 1));
			}
		};
		window.addEventListener("mousemove", onMouseMove);
		return () => { window.removeEventListener("mousemove", onMouseMove); };
	}, [guest, chatData?.isHiding]);

	useEffect(() => {
		const guestStarExists = document.getElementsByClassName("guestStarAvatar").length > 0;
		if (guest === guestStarExists) { return; }
		setGuest(guestStarExists);
	}, [guest, blinkTimer]);

	useEffect(() => {
		if (scare) { return; }
		const onClick = (event: MouseEvent) => {
			const avatar = document.getElementsByClassName("maidChan")[0]?.getBoundingClientRect();
			const content = document.getElementsByClassName("main")[0]?.getBoundingClientRect();
			if (!avatar || !content) { return; }
			const { x: mouseX, y: mouseY } = event;

			const withinX = mouseX > avatar.x && mouseX < avatar.x + avatar.width && (mouseX < content.x || mouseX > content.x + content.width);
			const withinY = mouseY > avatar.y && mouseY < avatar.y + avatar.height;

			if (withinX && withinY) {
				setClicks(x => x + 1);
				const random = Math.random();
				if (random < 0.1) {
					setScare(ScareReason.Clicked);
				}
				else {
					setTriggerBow(BowReason.Annoyed);
				}
			}
		};
		window.addEventListener("mouseup", onClick);
		return () => { window.removeEventListener("mouseup", onClick); };
	}, [scare, chatData?.isHiding]);

	const [showMessage, setShowMessage] = useState(true);
	useEffect(() => {
		if (clicks >= 1) {
			Get<{ clue: string }>("/chat/runaway")
				.then(resp => {
					setChatData?.(x => {
						if (!x) { return null; }
						return { ...x, isHiding: true, hidingMessage: resp.clue };
					});
					setClicks(0);
					setShowMessage(true);
				});
		}
	}, [clicks]);

	useEffect(() => {
		if (location === 0 || location === 3) { return; }
		const timeout = setTimeout(() => { setLocation(0); }, 5000);
		return () => { clearTimeout(timeout); };
	}, [location]);

	useEffect(() => {
		if (chatData?.isHiding) {
			setTriggerBow(BowReason.Baka);
		}
	}, [chatData?.isHiding]);

	
	if (chatData?.isHiding) {
		return <Modal
			className="maidchanMessage"
			open={showMessage}
			onClose={() => { setShowMessage(false); }}
			title="メイドちゃんより"
			content={<div className="maidchanMessageText">
				{chatData?.hidingMessage?.split("\n").map((line, i) => (
				  <p key={i}>{line}</p>
				))}
			  </div>}
			footer={<Button color="Blue" size="Medium" onClick={() => { setShowMessage(false); }} level="Secondary" leftIcon={<CrossIcon />}>Close</Button>}
		/>;
	}

	return <>
		<div id="mcCornerPicture" />
		<div id="mcPicEyesClosed" className={`maidChan mcEyesClosed location${location} ${dead ? "dead" : ""}`} style={closedStyle}></div>
		<div id="mcPicEyesOpen" className={`maidChan mcEyesOpen location${location} ${dead ? "dead" : ""}`} style={openStyle}></div>
		<div id="mcPicSmugEyes" className={`maidChan mcEyesOpen location${location} ${dead ? "dead" : ""}`} style={smugStyle}></div>
		<div id="mcPicBow" className={`maidChan mcEyesOpen location${location} ${dead ? "dead" : ""}`} style={bowStyle}></div>
		<MaidchanJumpScare scare={scare} lastBah={chatData?.lastBah} endScare={endScare} />
	</>;
}

export default Maidchan;